// extracted by mini-css-extract-plugin
module.exports = {"haggleModal":"styles_haggleModal__h1kmQ","haggleForm":"styles_haggleForm__xtIEg","submitButton":"styles_submitButton__8QdhA"};